import { origin } from './paired.js'

export default (
  element
) => {
  origin(element)
}
